module.exports = __webpack_public_path__ + "img/girl-and-pet.5ad2f754.svg";